import Input from "../../../controls/Input";
import ReportLotNumberLabel from "../ReportLotNumberLabel";
import FinanceProductFilters from "./FinanceProductFilters";
import SelectMenu from "../../../controls/SelectMenu";
import type {
  FinanceProductFilterOptions,
  FinanceReportFilters,
  ReportFilterOption,
  SetFinanceReportFilters,
} from "./types";

type Props = FinanceProductFilterOptions & {
  filters: FinanceReportFilters;
  rooms: ReportFilterOption[];
  roomEntityLabel: string;
  setFilters: SetFinanceReportFilters;
};

export default function ProductionCostYieldFilters({
  filters,
  setFilters,
  products,
  classes,
  categories,
  rooms,
  roomEntityLabel,
}: Props) {
  const update = (key: string, value: unknown) =>
    setFilters({ ...filters, [key]: value });

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
      <FinanceProductFilters
        filters={filters}
        setFilters={setFilters}
        classes={classes}
        categories={categories}
        products={products}
      />
      <SelectMenu
        title={roomEntityLabel}
        handleInputChange={(event: { target: { value: ReportFilterOption } }) =>
          update("room", event.target.value)
        }
        name="room"
        options={rooms}
        value={filters.room}
      />
      <Input
        label={
          <ReportLotNumberLabel
            report="financeProduction"
            htmlFor="lot_number"
          />
        }
        name="lot_number"
        value={filters.lot_number ?? ""}
        onChange={(event: { target: { value: string } }) =>
          update("lot_number", event.target.value)
        }
        labelOn
        type="text"
        className="input-brand mt-1 w-full"
      />
    </div>
  );
}
